export const alertEventNames = {
  DevStreamEventFcw: 'DevStreamEventFcw',
  DevStreamEventPcw: 'DevStreamEventPcw',
  DevStreamEventLdw: 'DevStreamEventLdw',
  DevStreamEventOverspeed: 'DevStreamEventOverspeed',
  DevStreamEventWireCut: 'DevStreamEventWireCut',
  DevStreamEventDrowsiness: 'DevStreamEventDrowsiness',
  DevStreamEventEyesOffRoad: 'DevStreamEventEyesOffRoad',
  DevStreamEventCameraBlockage: 'DevStreamEventCameraBlockage', // temp to support legacy events
  DevStreamEventCameraBlockageInterior: 'DevStreamEventCameraBlockageInterior',
  DevStreamEventCameraBlockageExterior: 'DevStreamEventCameraBlockageExterior',
  DevStreamEventMobilePhoneUsage: 'DevStreamEventMobilePhoneUsage',
  DevStreamEventTailgaiting: 'DevStreamEventTailgaiting',
  DevStreamEventAccidentCameraRemoval: 'DevStreamEventAccidentCameraRemoval',
  DevStreamEventHighG: 'DevStreamEventHighG',
  DevStreamEventHardBrake: 'DevStreamEventHardBrake',
  DevStreamEventHardAcceleration: 'DevStreamEventHardAcceleration',
  DevStreamEventHardTurn: 'DevStreamEventHardTurn',
  DevStreamDriverNotFound: 'DevStreamDriverNotFound',
  DevStreamUnauthorizedDriver: 'DevStreamUnauthorizedDriver',
  DrivingOvertime: 'DrivingOvertime',
  DriverUnauthorized: 'DriverUnauthorized',
  DriverUnknown: 'DriverUnknown',
};

export const alertEventKeys = {
  DevStreamEventFcw: 'config/ECDP/front_collision_warning',
  DevStreamEventPcw: 'config/ECDP/pedestrian_collision_warning',
  DevStreamEventLdw: 'config/ECDP/lane_departure_warning',
  DevStreamEventOverspeed: 'config/ECDP/speed_limit_warning',
  DevStreamEventWireCut: 'config/WIRE-CUT/wire_cut/active_warning',
  DevStreamEventDrowsiness: 'config/ICDP/drowsiness',
  DevStreamEventEyesOffRoad: 'config/ICDP/eyes_of_the_road',
  DevStreamEventCameraBlockage: 'DevStreamEventCameraBlockage', // temp to support legacy events
  DevStreamEventCameraBlockageInterior: 'config/ICDP/camera_blockage',
  DevStreamEventCameraBlockageExterior: 'config/ECDP/camera_blockage',
  DevStreamEventMobilePhoneUsage: 'config/ICDP/phone_usage',
  DevStreamEventTailgaiting: 'DevStreamEventTailgaiting',
  DevStreamEventAccidentCameraRemoval: 'DevStreamEventAccidentCameraRemoval',
  DevStreamEventHighG: 'config/IMU/high_g',
  DevStreamEventHardBrake: 'config/IMU/hard_brake',
  DevStreamEventHardAcceleration: 'config/IMU/hard_acceleration',
  DevStreamEventHardTurn: 'config/IMU/hard_turn',
  DevStreamDriverNotFound: 'config/ICDP/anti_spoofing',
  DevStreamUnauthorizedDriver: 'DevStreamUnauthorizedDriver',
  DrivingOvertime: 'DrivingOvertime',
  DriverUnauthorized: 'DriverUnauthorized',
  DriverUnknown: 'DriverUnknown',
};

export const alertEventsMap: Record<string, { shortDesc: string; fullDesc: string; badge: string }> = {
  DevStreamEventFcw: {
    shortDesc: 'Forward collision warning',
    fullDesc: 'The vehicle nearly crashed into another vehicle',
    badge: 'FCW',
  },
  DevStreamEventPcw: {
    shortDesc: 'Pedestrian collision warning',
    fullDesc: 'The vehicle nearly hit a pedestrian',
    badge: 'PCW',
  },
  DevStreamEventLdw: {
    shortDesc: 'Lane departure warning',
    fullDesc: 'The vehicle left its lane in a dangerous way',
    badge: 'LDW',
  },
  DevStreamEventOverspeed: {
    shortDesc: 'Over speeding warning',
    fullDesc: 'The vehicle drove above the speed limit defined for this road',
    badge: 'Speed',
  },
  DevStreamEventWireCut: {
    shortDesc: 'Power Supply Cut Warning',
    fullDesc: 'The Device facing issue with power supply cut',
    badge: 'Power cut',
  },
  DevStreamEventDrowsiness: {
    shortDesc: 'Drowsiness warning',
    fullDesc: 'The driver operated the vehicle when too fatigued or sleepy',
    badge: 'Drowsiness',
  },
  DevStreamEventEyesOffRoad: {
    shortDesc: 'Eyes off road',
    fullDesc: 'The driver was distracted and did not look at the road',
    badge: 'Eyes off road',
  },
  DevStreamEventCameraBlockage: {
    shortDesc: 'The camera field or view is blocked',
    fullDesc: 'The camera field of view was fully or partially blocked',
    badge: 'Camera blocked',
  },
  DevStreamEventCameraBlockageInterior: {
    shortDesc: 'The interior camera field or view is blocked',
    fullDesc: 'The interior camera field of view was fully or partially blocked',
    badge: 'Int. camera blocked',
  },
  DevStreamEventCameraBlockageExterior: {
    shortDesc: 'The exterior camera field or view is blocked',
    fullDesc: 'The exterior camera field of view was fully or partially blocked',
    badge: 'Ext. camera blocked',
  },
  DevStreamEventMobilePhoneUsage: {
    shortDesc: 'Mobile phone usage',
    fullDesc: 'The driver was distracted by using a mobile phone',
    badge: 'Mobile phone',
  },
  DevStreamEventTailgaiting: {
    shortDesc: 'Tailgating warning',
    fullDesc: 'Driving behind another vehicle while not leaving sufficient distance to stop',
    badge: 'Tailgating',
  },
  DevStreamEventAccidentCameraRemoval: {
    shortDesc: 'Camera removal warning',
    fullDesc: 'The camera was removed from the vehicle',
    badge: 'Camera removal',
  },
  DevStreamEventHighG: {
    shortDesc: 'High G warning',
    fullDesc: 'The vehicle experienced high G',
    badge: 'High G',
  },
  DevStreamEventHardBrake: {
    shortDesc: 'Hard brake warning',
    fullDesc: 'The vehicle made a hard stop',
    badge: 'Hard brake',
  },
  DevStreamEventHardAcceleration: {
    shortDesc: 'Hard acceleration warning',
    fullDesc: 'The vehicle made a hard acceleration',
    badge: 'Hard acceleration',
  },
  DevStreamEventHardTurn: {
    shortDesc: 'Hard turn warning',
    fullDesc: 'The vehicle made a hard turn',
    badge: 'Hard turn',
  },
  DevStreamDriverNotFound: {
    shortDesc: 'Driver Obstruction',
    fullDesc: 'Driver obstruction',
    badge: 'Driver obstruction',
  },
  DrivingOvertime: {
    shortDesc: 'Driving Overtime warning',
    fullDesc: 'Driver reached the limit of driving hours',
    badge: 'Driving overtime',
  },
  DriverUnauthorized: {
    shortDesc: 'Unauthorized driver detected',
    fullDesc: 'Driver who is not authorized is driving the vehicle',
    badge: 'Unauthorized driver',
  },
  DriverUnknown: {
    shortDesc: 'Unknown driver detected',
    fullDesc: 'Driver who is not identified is driving the vehicle',
    badge: 'Unknown driver',
  },
  // TODO unblock when backend is ready
  // DevStreamUnauthorizedDriver: {
  //   shortDesc: 'Unauthorized driver detected',
  //   fullDesc: 'Driver who is not authorized is driving the vehicle',
  //   badge: 'Unauthorized driver',
  // },
};
